import { Question } from 'next-seo/lib/jsonld/faqPage';

const linkProps = {
  target: '_blank',
  rel: 'noreferrer noopener',
};

export const faqData = [
  {
    title: 'What does a medical recruitment agency do?',
    content: (
      <>
        We find our doctors{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-australia" {...linkProps}>
          locum placements
        </a>{' '}
        or{' '}
        <a
          href="https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
          {...linkProps}
        >
          permanent (full-time) positions
        </a>{' '}
        to suit your career or lifestyle goals. Our team of recruitment specialists takes care of
        the medical job search, pay negotiation, paperwork, and travel logistics - so you can focus
        on practicing medicine. We form strong relationships with the healthcare facilities to
        ensure a seamless match between doctors and institutions for the most mutually beneficial
        partnerships.
      </>
    ),
    plainTextContent:
      'We find our doctors locum placements or permanent (full-time) positions to suit your career or lifestyle goals. Our team of recruitment specialists takes care of the medical job search, pay negotiation, paperwork, and travel logistics - so you can focus on practicing medicine. We form strong relationships with the healthcare facilities to ensure a seamless match between doctors and institutions for the most mutually beneficial partnerships.',
  },
  {
    title: 'What is Medrecruit?',
    content: (
      <>
        Medrecruit is doctor owned and operated recruitment agency, specialising in{' '}
        <a
          href="https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
          {...linkProps}
        >
          permanent
        </a>{' '}
        and{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-australia" {...linkProps}>
          locum jobs.
        </a>{' '}
        We are committed to connecting doctors with job opportunities that fit their career and
        lifestyle goals and our exclusive network of jobs across Australasia allows us to
        personalise each placement. Whether you're after long-term or short-term work, locum or
        permanent positions - we've got you covered.
      </>
    ),
    plainTextContent:
      "Medrecruit is doctor owned and operated recruitment agency, specialising in permanent and locum jobs. We are committed to connecting doctors with job opportunities that fit their career and lifestyle goals and our exclusive network of jobs across Australasia allows us to personalise each placement. Whether you're after long-term or short-term work, locum or permanent positions - we've got you covered.",
  },
  {
    title: 'Why should I work with a medical recruitment agency?',
    content: (
      <>
        Known as one of the best medical locum recruitment agencies in Australia and New Zealand,
        we're preferred suppliers to hospitals and health care practices across Australasia. This
        means we can get jobs to you before they've reached the market. Our recruiters and dedicated
        placement teams go the extra mile to deliver exceptional service and be the very best locum
        agency. Our consultants are experienced, knowledgeable and strong negotiators. They will
        find the right job for you at the best rate.
        {/* TODO - get in touch button */}
      </>
    ),
    plainTextContent:
      "Known as one of the best medical locum recruitment agencies in Australia and New Zealand, we're preferred suppliers to hospitals and health care practices across Australasia. This means we can get jobs to you before they've reached the market. Our recruiters and dedicated placement teams go the extra mile to deliver exceptional service and be the very best locum agency. Our consultants are experienced, knowledgeable and strong negotiators. They will find the right job for you at the best rate.",
  },
  {
    title: 'Who do you work with?',
    content: (
      <>
        As a doctor recruitment agency, we work with medical doctors to help them find work in{' '}
        <a href="https://medrecruit.medworld.com/doctors/doctor-jobs-australia" {...linkProps}>
          Australia
        </a>{' '}
        and{' '}
        <a href="https://medrecruit.medworld.com/doctors/doctor-jobs-new-zealand" {...linkProps}>
          New Zealand
        </a>
        . We have thousands of{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-australia" {...linkProps}>
          locum roles
        </a>{' '}
        and{' '}
        <a
          href="https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
          {...linkProps}
        >
          full-time roles
        </a>{' '}
        in hospitals and general practices across Australasia on our books. We specialise in doctor
        recruitment, so if you are a medical doctor looking for a new career in Australia or New
        Zealand we would love to help!
      </>
    ),
    plainTextContent:
      'As a doctor recruitment agency, we work with medical doctors to help them find work in Australia and New Zealand. We have thousands of locum roles and full-time roles in hospitals and general practices across Australasia on our books. We specialise in doctor recruitment, so if you are a medical doctor looking for a new career in Australia or New Zealand we would love to help!',
  },
  {
    title: 'What is locum work?',
    content: (
      <>
        Locum work, also known as locum tenens positions, for medical doctors in{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-australia" {...linkProps}>
          Australia
        </a>{' '}
        and{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-new-zealand" {...linkProps}>
          New Zealand
        </a>{' '}
        refers to temporary positions that provide flexibility in scheduling and diverse clinical
        experiences. Doctors can take on short-term assignments to cover staff shortages or fill in
        for colleagues on leave, often facilitated through locum agencies with expert locum
        recruiters. This allows them to gain exposure to various healthcare settings, enhance their
        skills, maintain a healthy work-life balance, and, oftentimes, earn more. Locum work is an
        excellent option for those seeking variety in their medical career or exploring different
        regions.
      </>
    ),
    plainTextContent:
      'Locum work, also known as locum tenens positions, for medical doctors in Australia and New Zealand refers to temporary positions that provide flexibility in scheduling and diverse clinical experiences. Doctors can take on short-term assignments to cover staff shortages or fill in for colleagues on leave, often facilitated through locum agencies with expert locum recruiters. This allows them to gain exposure to various healthcare settings, enhance their skills, maintain a healthy work-life balance, and, oftentimes, earn more. Locum work is an excellent option for those seeking variety in their medical career or exploring different regions.',
  },
  {
    title: 'What are the benefits of working as a locum doctor in Australia and New Zealand?',
    content: (
      <>
        Working as a locum doctor in{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-australia" {...linkProps}>
          Australia
        </a>{' '}
        and{' '}
        <a href="https://medrecruit.medworld.com/doctors/locum-jobs-new-zealand" {...linkProps}>
          New Zealand
        </a>{' '}
        presents a myriad of benefits. These positions offer flexibility, allowing doctors to tailor
        their schedules and explore diverse healthcare environments. With the assistance of locum
        agencies in Australia and New Zealand, doctors can seamlessly navigate the recruitment
        process, leveraging the expertise of recruitment agencies for medical staff to secure
        rewarding opportunities. Beyond flexibility, locum roles often boast competitive pay rates,
        free travel and accommodation, making them highly sought-after. By working with a trusted
        locum tenens agency, doctors gain access to a vast network of locum opportunities across
        various specialties and regions. Whether you're an experienced practitioner or seeking to
        embark on a new adventure, locum positions offer unparalleled flexibility and diversity in
        both Australia and New Zealand.
      </>
    ),
    plainTextContent:
      "Working as a locum doctor in Australia and New Zealand presents a myriad of benefits. These positions offer flexibility, allowing doctors to tailor their schedules and explore diverse healthcare environments. With the assistance of locum agencies in Australia and New Zealand, doctors can seamlessly navigate the recruitment process, leveraging the expertise of recruitment agencies for medical staff to secure rewarding opportunities. Beyond flexibility, locum roles often boast competitive pay rates, free travel and accommodation, making them highly sought-after. By working with a trusted locum tenens agency, doctors gain access to a vast network of locum opportunities across various specialties and regions. Whether you're an experienced practitioner or seeking to embark on a new adventure, locum positions offer unparalleled flexibility and diversity in both Australia and New Zealand.",
  },
  {
    title:
      'Can I work as a doctor in Australia and New Zealand as an International Medical Graduate?',
    content: (
      <>
        As an International Medical Graduate (IMG), working in{' '}
        <a href="https://medrecruit.medworld.com/doctors/doctor-jobs-new-zealand" {...linkProps}>
          New Zealand
        </a>{' '}
        and{' '}
        <a href="https://medrecruit.medworld.com/doctors/doctor-jobs-australia" {...linkProps}>
          Australia
        </a>{' '}
        is indeed possible. However, it involves a structured process overseen by the respective
        medical councils. In Australia, the Medical Council of Australia manages the registration
        process, and in New Zealand, the Medical Council of New Zealand ensures that IMGs meet the
        required standards and qualifications. Partnering with a doctor recruitment agency like
        Medrecruit can help facilitate the transition process for IMGs, guiding them through the
        registration process and assisting in securing suitable placements. These agencies
        specialise in connecting doctors with opportunities across various healthcare settings,
        ensuring a smooth transition into working in New Zealand and Australia for IMGs seeking
        fulfilling careers in these countries. Head to{' '}
        <a href="https://medrecruit.medworld.com/doctors/international" {...linkProps}>
          this page for IMGs
        </a>{' '}
        for more information on how Medrecruit can support.
      </>
    ),
    plainTextContent:
      'As an International Medical Graduate (IMG), working in New Zealand and Australia is indeed possible. However, it involves a structured process overseen by the respective medical councils. In Australia, the Medical Council of Australia manages the registration process, and in New Zealand, the Medical Council of New Zealand ensures that IMGs meet the required standards and qualifications. Partnering with a doctor recruitment agency like Medrecruit can help facilitate the transition process for IMGs, guiding them through the registration process and assisting in securing suitable placements. These agencies specialise in connecting doctors with opportunities across various healthcare settings, ensuring a smooth transition into working in New Zealand and Australia for IMGs seeking fulfilling careers in these countries. Head to this page for IMGs for more information on how Medrecruit can support.',
  },
];

export const faqSeoSchemaData: Question[] = faqData.map(({ title, plainTextContent }) => ({
  questionName: title,
  acceptedAnswerText: plainTextContent,
}));
